// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1Ho_A","upload":"Small_upload__2946l","imageWrap":"Small_imageWrap__c51HU","removeBtn":"Small_removeBtn__1TslP"};